import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';

import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchItemData, fetchItemMaterialData } from '../../../Store/PHPSlice/Item';
import { selectItemMaterialData, selectItems } from '../../Selectors/Master/ItemSelectors';
import { Preview } from '@mui/icons-material';

const MaterialView = () => {
    const { Id } = useParams();
    const [material, setMaterial] = useState([]);
    const [formData, setFormData] = useState({});
    const dispatch = useDispatch();
    const materialData = useSelector(selectItemMaterialData);
    const itemSize = useSelector(selectItems);
    const [size, setSize] = useState([]);

    useEffect(() => {
        dispatch(fetchItemMaterialData(Id));
        dispatch(fetchItemData(Id));
    }, [dispatch, Id]);

    useEffect(() => {
        if (materialData?.data?.length > 0) {
            const data = materialData?.data;
            setMaterial(data);

            const data2 = materialData?.data[0];
            setFormData(data2);
        }
    }, [materialData]);

    useEffect(() => {
        if (itemSize?.data?.length > 0) {
            const item = itemSize.data[0];
            const sizeStr = item?.size || '';
            const arr = sizeStr ? sizeStr.split(',') : [];
            setSize(arr);
        } else {
            setSize([]);
        }
    }, [itemSize]);


    const handleSizeWiseView = (id) => {
        window.open(`/sizewise-material-view/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    console.log(material)
    return (
        <>

            <div style={{ margin: '1% 0.5%' }}>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>

                            <h3 className='centered-heading'>Item Wise Material List</h3>
                            <div className="dashed-line"></div>

                            {/* <table>
                                <tr>
                                    <td>Item</td>
                                    <td>{formData?.itemNm}</td>
                                    <td>Brand</td>
                                    <td>{formData?.brandNm}</td>
                                </tr>
                            </table> */}

                            {/* <div>

                                <table style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Material</th>
                                            <th>Type</th>
                                            <th>View</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {material?.map((mat, matIndex) => (
                                            <>
                                                <tr key={matIndex}>
                                                    <td>
                                                        {matIndex + 1}
                                                    </td>
                                                    <td>
                                                        {mat.materialNm}
                                                    </td>
                                                    <td>{mat.mtype}</td>
                                                    <td>
                                                        {mat?.sizewise?.length > 0 ? <Preview onClick={() => handleSizeWiseView(mat.ID)} className='cursor-pointer' /> : '-'}
                                                    </td>

                                                </tr>
                                            </>
                                        ))}

                                    </tbody>
                                </table>

                            </div> */}


                            <div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ fontWeight: '600' }}>Item Name</th>
                                            <th>Size</th>
                                            {size.map((item, index) => (
                                                <th key={index}>{item}</th>
                                            ))}
                                            <th>Details</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {size?.length > 0 && material?.map((item, index) => (
                                            <tr key={index}>
                                                {index === 0 && (
                                                    <td rowSpan={material?.length} style={{ fontWeight: '600' }}>
                                                        {formData.itemNm}
                                                    </td>
                                                )}
                                                <td>{item.materialNm}</td>
                                                {size.map((sz, sidx) => {
                                                    const matched = item?.sizewise?.find(val => val.size === sz);

                                                    return (
                                                        <td key={sidx}>
                                                            {matched ? (
                                                                <>
                                                                    {matched.matsize}
                                                                    <br />
                                                                    <hr />
                                                                    {matched.qty}
                                                                </>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </td>
                                                    );
                                                })}


                                                <td>{item.mtype}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>


                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default MaterialView;
